import { useState } from "react";
import { Coins, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import PersonnelTab from "@/pages/accounting/PersonnelTab";

export default function Personnel() {
  const { can } = useAuth();
  const canWrite = can("accounting.payroll") || can("accounting.write");
  const [openNew, setOpenNew] = useState(false);
  return (
    <div className="space-y-4 fade-in" data-testid="personnel-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Coins className="h-5 w-5 text-brand-green" />
          <div>
            <p className="overline">İnsan Kaynakları</p>
            <h1 className="font-heading text-2xl font-bold text-slate-900">Personel &amp; Bordro</h1>
            <p className="mt-1 text-sm text-slate-500" data-testid="personnel-purpose">Personel kartları, maaş, avans, prim ve aylık bordro. Mali kayıtlar <b>Muhasebe</b>'de tutulur.</p>
          </div>
        </div>
        {canWrite && (
          <Button data-testid="personnel-add-btn" onClick={() => setOpenNew(true)} className="bg-brand-green text-white hover:bg-brand-green-600">
            <Plus className="mr-1.5 h-4 w-4" /> Yeni Personel
          </Button>
        )}
      </div>
      <PersonnelTab canWrite={canWrite} openNew={openNew} setOpenNew={setOpenNew} />
    </div>
  );
}
